import { MediaType } from '../MediaType';
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';

export const experimentalDeleteContentVersion: ExperimentalMutations['experimentalDeleteContentVersion'] =
	(_, { contentId, versionNumber }, { network: { cfetch, BadStatusError } }) =>
		cfetch(`/wiki/rest/api/content/${contentId}/version/${versionNumber}`, {
			method: 'DELETE',
			headers: {
				Accept: MediaType.JSON,
				'Content-Type': MediaType.JSON,
			},
		}).then(
			/* onFulfilled */ () => true,
			/* onRejected */ (reason) => {
				if (BadStatusError.isBadStatusError(reason)) {
					return false;
				}

				throw reason;
			},
		);
